import React from 'react';
import { useAppSelector } from 'app/hooks';
import { DocumentsTab } from 'screen/counselor/components/documents/DocumentsTab';

/** Student application nav: the logged-in student's own documents. */
const DocumentsPage = () => {
  const info = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const studentId = Number(info?.student_id);

  if (!studentId) {
    return null;
  }

  return (
    <DocumentsTab
      studentId={studentId}
      viewerRole="student"
      studentFirstName={info?.first_name || ''}
    />
  );
};

export default DocumentsPage;
